import { render, staticRenderFns } from "./_blog.vue?vue&type=template&id=107a30be"
import script from "./_blog.vue?vue&type=script&lang=js"
export * from "./_blog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports